import { render, staticRenderFns } from "./match_dan_his.vue?vue&type=template&id=ce839888&scoped=true&"
import script from "./match_dan_his.vue?vue&type=script&lang=js&"
export * from "./match_dan_his.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce839888",
  null
  
)

export default component.exports